// extracted by mini-css-extract-plugin
export default {"top":"Blob_top__S7qXl","rotate":"Blob_rotate__h-psX","middle":"Blob_middle__euXng","bottom":"Blob_bottom__QdoH7","blobs":"Blob_blobs__UaykL"};